import FootballStatsCategory from "../../stats/football-stats-category";
import FootballState from "../../state/football-state";
import StatsRule from "../../../common/stats-rule";

export default class ContinueTouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            play.historyContains(FootballState.Continue) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const rushFragment = play.getPreceedingFragment(fragment, [
            FootballState.Continue
        ]);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: rushFragment.continuedBy.teamId,
            playerId: rushFragment.continuedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: rushFragment.id,
            category: FootballStatsCategory.RUSHING_TOUCHDOWN,
            values: {
                completed: 1
            }
        });
    }
}
